import { Component, OnInit } from "@angular/core";
import {
  trigger,
  transition,
  style,
  animate,
  state,
} from "@angular/animations";
import { slideToLeftTransition } from "../../animations";
import { WindowService } from "@app/services/window.service";
import { AfterViewInit } from "@angular/core";
import { UserService } from "@app/services/user.service";
import { FeatureRequestService } from "@app/services/feature-request.service";
import { FeatureRequest } from "@app/data/feature-request";
import { User } from "@app/data/user";
import * as _ from "underscore";

@Component({
  templateUrl: "./feature-requests.component.html",
})
export class FeatureRequestsComponent implements OnInit {
  user: User;
  featureRequests: FeatureRequest[];
  featureRequest: FeatureRequest = new FeatureRequest();

  constructor(
    private userService: UserService,
    private featureRequestService: FeatureRequestService
  ) {}

  ngOnInit(): void {
    //localhost:3500
    http: this.userService.me().then((user) => {
      this.user = user;
      this.loadFeatureRequests();
    });
  }

  loadFeatureRequests() {
    this.featureRequestService.all().then((featureRequests) => {
      this.featureRequests = _.sortBy(featureRequests, (featureRequest) => {
        return featureRequest.status;
      }).reverse();
    });
  }

  vote(featureRequest: FeatureRequest) {
    this.featureRequestService.vote(featureRequest._id).then(() => {
      this.loadFeatureRequests();
    });
  }

  onSubmit() {
    this.featureRequestService
      .create(this.featureRequest)
      .then((featureRequest) => {
        this.featureRequest = new FeatureRequest();
        this.loadFeatureRequests();
      });
  }
  z;
}
